import { orchestrator } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
import { updateOWAConnectedAccountStatus, OWAConnectedAccountState } from 'owa-accounts-store';
import { setIsLeftNavShown } from '../mutators/leftNavStateMutators';

orchestrator(updateOWAConnectedAccountStatus, actionMessage => {
    const { accountState } = actionMessage;
    if (
        accountState != OWAConnectedAccountState.Valid &&
        !getUserConfiguration()?.ViewStateConfiguration?.CalendarSidePanelIsExpanded
    ) {
        setIsLeftNavShown(true);
    }
});
